import React, { useEffect, useRef, useState } from "react";

import "./index.css"

const ProductViewer = ({ packagingView360Data }) => {
    const canvasRef = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isRotating, setIsRotating] = useState(false);
    const [autoRotate, setAutoRotate] = useState(true);
    const [onHoverRotate, setOnHoverRotate] = useState(false);
    const [dragging, setDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const rotationSpeed = 1; 

    const imagesURL = packagingView360Data?.images;
    // const imageURL = imagesURL[currentImageIndex]?.gatsbyImageData?.images?.fallback.src;
    const imageURL = imagesURL?.[currentImageIndex]?.gatsbyImageData?.images?.fallback?.src;

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.onload = function () {
            canvas.height = img.height;
            canvas.width = img.width;
            ctx.drawImage(img, 0, 0);
            setImageLoaded(true);
        };

        img.src = imageURL;

        const rotateCanvas = () => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imagesURL?.length);
        };

        let rotationInterval;

        if (isRotating || autoRotate) {
            const intervalDuration = 1000 / (rotationSpeed * 5);
            rotationInterval = setInterval(rotateCanvas, intervalDuration);
        } else {
            clearInterval(rotationInterval);
        }

        return () => {
            clearInterval(rotationInterval);
        };
    }, [imageURL, isRotating, currentImageIndex, imagesURL, rotationSpeed, autoRotate]);

    const handleAutoRotate = () => {
        setAutoRotate(!autoRotate);
        if (!autoRotate) {
            setIsRotating(true);
        } else {
            setIsRotating(false);
        }
    };

    const handleOnHoverRotate = () => {
        setOnHoverRotate(!onHoverRotate);
    };

    const handleMouseEnter = () => {
        if (onHoverRotate) {
            setIsRotating(true);
        }
    };

    const handleMouseLeave = () => {
        setIsRotating(false);
    };

    const handleMouseDown = (event) => {
        setDragging(true);
        setStartX(event.clientX);
    };

    const handleMouseMove = (event) => {
        if (dragging) {
            const deltaX = event.clientX - startX;
            if (deltaX > 50) {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imagesURL?.length);
                setStartX(event.clientX);
            } else if (deltaX < -50) {
                setCurrentImageIndex((prevIndex) => (prevIndex - 1 + imagesURL?.length) % imagesURL?.length);
                setStartX(event.clientX);
            }
        }
    };

    const handleMouseUp = () => {
        setDragging(false);
    };

    const handleTouchStart = (event) => {
        setDragging(true);
        setStartX(event.touches[0].clientX);
    };

    const handleTouchMove = (event) => {
        if (dragging) {
            const deltaX = event.touches[0].clientX - startX;
            if (deltaX > 50) {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imagesURL?.length);
                setStartX(event.touches[0].clientX);
            } else if (deltaX < -50) {
                setCurrentImageIndex((prevIndex) => (prevIndex - 1 + imagesURL?.length) % imagesURL?.length);
                setStartX(event.touches[0].clientX);
            }
        }
    };

    const handleTouchEnd = () => {
        setDragging(false);
    };

    return (
        <div className="relative component-product-viewer">
            <div
                style={{ position: 'relative', display: 'inline-block', width: '100%', textAlign: 'center', backgroundColor: packagingView360Data?.colorPicker }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <img src={imageURL} alt="Product" className="product-viewer--image"/>
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: packagingView360Data?.colorPicker || '#fff' }}>
                    <canvas
                        ref={canvasRef}
                        className={`product-viewer--canvas${(autoRotate || isRotating) ? ' canvas-transition' : ''}`}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                    ></canvas>
                </div>
                {!imageLoaded && <p>Loading image...</p>}
            </div>
            {packagingView360Data?.titleVisibility && <p className="mt-5 mb-5 text-left "><span className="bold">{packagingView360Data?.mediaSliderName}</span></p>}
            <div className="absolute" style={{ display: 'block', bottom: '35px', right: 0 }}>
                <button type="button" className="btn-brand-color" onClick={handleAutoRotate} style={{ padding: '9px 8px', marginBottom: '10px', marginRight: '15px', fontSize: '12px', borderRadius: '5px' }}>{!autoRotate ? 'Start Auto Rotate':'Stop Auto Rotate'}</button>
                <button type="button" className="btn-brand-color" onClick={handleOnHoverRotate} style={{ padding: '9px 8px', marginRight: '15px', fontSize: '12px', borderRadius: '5px' }}>Toggle On Hover Rotation</button>
            </div>
        </div>
    );
};

export default ProductViewer;

